import React, { useState } from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import DataEntryModal from '@grnhse/seedling/lib/birch/components/modals/data_entry_modal';
import { TextInput } from '@grnhse/seedling/lib/birch/components/forms/text_input';
import {
  PrimaryButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';

const t = withLocalePrefix('talent_rediscovery.filters.modal');

type Props = {
  isOpen: boolean;
  close: () => void;
  onSave: (name: string) => void;
  filterNames: Array<string | undefined | null>;
};

const SaveFiltersModal = ({ isOpen, close, onSave, filterNames }: Props) => {
  const [selectedName, setSelectedName] = useState('');
  const [hasValidationError, setHasValidationError] = useState(false);

  const onClose = () => {
    setSelectedName('');
    setHasValidationError(false);
    close();
  };

  const onSubmit = async () => {
    if (filterNames?.includes(selectedName)) {
      setHasValidationError(true);
      return;
    } else {
      setHasValidationError(false);
      onSave(selectedName);
      close();
    }
  };

  return (
    <DataEntryModal
      size="medium"
      isOpen={isOpen}
      onDismiss={onClose}
      ariaLabel={t('labels.save_filter_modal')}
    >
      <DataEntryModal.Header onClick={onClose}>
        {t('labels.save_filter_as')}
      </DataEntryModal.Header>
      <DataEntryModal.Body>
        <Stack sx={{ marginBottom: 2 }}>
          <TextInput
            value={selectedName}
            onChange={(e) => setSelectedName(e.currentTarget.value)}
            label={t('labels.filter_name')}
            error={hasValidationError}
            helperText={hasValidationError ? t('errors.name_taken') : ''}
          />
        </Stack>
      </DataEntryModal.Body>
      <DataEntryModal.Footer>
        <Stack direction="row" justifyContent="flex-end">
          <SecondaryButton onClick={onClose}>
            {t('actions.cancel')}
          </SecondaryButton>
          <PrimaryButton
            onClick={onSubmit}
            data-provides={'talent-rediscovery-save-new-filter-button'}
          >
            {t('actions.save')}
          </PrimaryButton>
        </Stack>
      </DataEntryModal.Footer>
    </DataEntryModal>
  );
};

export default SaveFiltersModal;
